export const reportOptions = ["Weekly", "Monthly", "Quarterly", "Yearly", "Ad-hoc"]
